import { useParams } from '../../../contexts/RouterContext';
import type { ReportsV3Params, ReportType } from '../types';

/**
 * Helper for grabbing the report type from the URL params.
 */
export const useReportType = (): ReportType => {
  const { reportType } = useParams<ReportsV3Params>();
  return reportType;
};
